import { request } from '../utils/request';

/**
 * 获取客户端列表（GET/POST 均可，支持 clientName/clientId/createUserName 筛选）
 * 接口: GET/POST /api/IdsClient/GetAllClient
 * 响应: res_content 为数组，无分页
 */
export const getAllClient = (data = {}) => {
  return request({
    url: 'IdsClient/GetAllClient',
    method: 'post',
    data: {
      clientName: data.clientName ?? data.ClientName ?? '',
      clientId: data.clientId ?? data.ClientId ?? '',
      createUserName: data.createUserName ?? data.CreateUserName ?? '',
    },
  });
};

/** @deprecated 请使用 getAllClient */
export const getIdsClientPageList = (data) => {
  return getAllClient({
    clientName: data?.Query?.ClientName,
    clientId: data?.Query?.ClientId,
    createUserName: data?.Query?.CreateUserName,
  });
};

/**
 * 获取客户端详情
 * 接口: GET /api/IdsClient/GetClientDetail
 * 请求参数: id (int, 必填)
 */
export const getClientDetail = (params) => {
  return request({
    url: 'IdsClient/GetClientDetail',
    method: 'get',
    params: { id: params?.id },
  });
};

/**
 * 新增或编辑客户端
 * 接口: POST /api/IdsClient/AddOrUpdateAsync
 */
export const addOrUpdateClient = (data) => {
  return request({
    url: 'IdsClient/AddOrUpdate',
    method: 'post',
    data,
  });
};

/**
 * 根据主键 ID 获取客户端密钥列表
 * 接口: GET /api/IdsApiSecret/GetSecretByMasterId?id=xxx
 */
export const getSecretByMasterId = (params) => {
  return request({
    url: 'IdsApiSecret/GetSecretByMasterId',
    method: 'get',
    params: { id: params?.id },
  });
};

/**
 * 生成客户端密钥
 * 接口: POST /api/IdsClient/GenerateSercetKey，无需参数
 */
export const generateSecretKey = () => {
  return request({
    url: 'IdsClient/GenerateSercetKey',
    method: 'post',
    data: {},
  });
};

/**
 * 获取所有权限范围
 * 接口: GET /api/IdsApiScope/GetAllApiScopes，无参数
 */
export const getAllApiScopes = () => {
  return request({
    url: 'IdsApiScope/GetAllApiScopes',
    method: 'get',
  });
};

/**
 * 权限范围搜索（简化版，适合下拉）
 * 接口: GET /api/IdsApiScope/GetSpecifyApiScopes，参数 keyword
 */
export const getSpecifyApiScopes = (params) => {
  return request({
    url: 'IdsApiScope/GetSpecifyApiScopes',
    method: 'get',
    params: params ?? {},
  });
};

/**
 * 客户端系统停用
 */
export const updateStatus = (data) => {
  return request({
    url: 'UserSystemPermissionsMapping/UpdateStatus',
    method: 'post',
    data,
  });
};

/**
 * 数据源：erpa_user_tbl（绑定用户、系统管理员下拉）
 */
export const executeDataSource = (data) => {
  return request({
    url: 'DataSource/EexcuteDataSource',
    method: 'post',
    data: { data_source_code: data?.data_source_code ?? 'erpa_user_tbl' },
  });
};
